import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAIChat } from './AiChatProvider'; // Assuming this is your context provider

const AIRouteListener = () => {
  const location = useLocation();
  const { resetCurrentConversation } = useAIChat();

  useEffect(() => {
    const isChatRoute = location.pathname.startsWith('/chat');
    if (!isChatRoute) {
      resetCurrentConversation();
    }
  }, [location, resetCurrentConversation]);

  return null;
};

export default AIRouteListener;
